export default "__VITE_ASSET__CjitP8nm__"